import type { FaceType } from './api.types';
import { FaceType as FaceTypeValue } from './api.types';

export interface FaceTypeOption {
  value: FaceType;
  icon: string;
  badgeIcon?: string;
  labelKey: string;
}

export const FACE_TYPE_OPTIONS: FaceTypeOption[] = [
  { value: FaceTypeValue.Unrated, icon: 'fa-regular fa-circle-question', labelKey: 'faceRatings.types.unrated' },
  { value: FaceTypeValue.Smile, icon: 'fa-regular fa-face-smile', labelKey: 'faceRatings.types.smile' },
  { value: FaceTypeValue.SadOrCrying, icon: 'fa-regular fa-face-sad-cry', labelKey: 'faceRatings.types.sadOrCrying' },
  { value: FaceTypeValue.Indeterminate, icon: 'fa-regular fa-face-meh', labelKey: 'faceRatings.types.indeterminate' },
  { value: FaceTypeValue.BackOfHead, icon: 'fa-regular fa-user', labelKey: 'faceRatings.types.backOfHead' },
  {
    value: FaceTypeValue.Partial,
    icon: 'fa-regular fa-user',
    badgeIcon: 'fa-minus',
    labelKey: 'faceRatings.types.partial',
  },
  { value: FaceTypeValue.Angry, icon: 'fa-regular fa-face-angry', labelKey: 'faceRatings.types.angry' },
  { value: FaceTypeValue.Astonished, icon: 'fa-regular fa-face-surprise', labelKey: 'faceRatings.types.astonished' },
];
